import { css, CSSResult, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { trackMaterialAvailable, trackMaterialViewed } from '../tracking/trackingLayer.js';

let availableTracked = false;
let viewedTracked = false;

@customElement('ents-material-tracking')
export class MaterialTracking extends LitElement {
  @property({ type: String, attribute: 'material', reflect: false })
  material = '';

  private viewObserver: IntersectionObserver | null = null;

  static readonly styles: CSSResult = css`
    :host {
      display: none;
    }
  `;

  protected firstUpdated() {
    if (!this.material) {
      return;
    }
    if (!availableTracked) {
      availableTracked = true;
      trackMaterialAvailable(this.material);
    }
    this.observeName();
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.viewObserver?.disconnect();
  }

  private observeName(): void {
    const anchor = this.closest('.ents-product-summary')?.querySelector('.ents-product-summary__name');
    if (viewedTracked || !anchor) {
      return;
    }
    this.viewObserver = new IntersectionObserver(
      (entries) => {
        if (!viewedTracked && entries.some((entry) => entry.isIntersecting)) {
          viewedTracked = true;
          trackMaterialViewed(this.material);
          this.viewObserver?.disconnect();
        }
      },
      { threshold: 0 },
    );
    this.viewObserver.observe(anchor);
  }
}
